import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, type ReactNode } from "react";
export default function CreateWaveFlow(t0) {
  const $ = _c(12);
  const {
    title,
    onBack,
    children,
    isActive: t1
  } = t0;
  const isActive = t1 === undefined ? true : t1;
  const onBackRef = useRef(onBack);
  let t2;
  let t3;
  if ($[0] !== onBack) {
    t2 = () => {
      onBackRef.current = onBack;
    };
    t3 = [onBack];
    $[0] = onBack;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      onBackRef.current?.();
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleBack = t4;
  let t5;
  let t6;
  if ($[4] !== isActive) {
    t5 = () => {
      const browserWindow = globalThis.window;
      if (!browserWindow || !isActive) {
        return;
      }
      const handleKeyDown = event => {
        if (event.key !== "Escape") {
          return;
        }
        const target = event.target as HTMLElement | null;
        const tagName = target?.tagName.toLowerCase();
        if (tagName === "input" || tagName === "textarea" || tagName === "select") {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        handleBack();
      };
      browserWindow.addEventListener("keydown", handleKeyDown);
      return () => {
        browserWindow.removeEventListener("keydown", handleKeyDown);
      };
    };
    t6 = [handleBack, isActive];
    $[4] = isActive;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  useEffect(t5, t6);
  let t7;
  if ($[7] !== children) {
    t7 = <div className="tw-h-full tw-w-full">{children}</div>;
    $[7] = children;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t7 || $[10] !== title) {
    t8 = <div className="tailwind-scope tw-bg-iron-950" data-flow-title={title}>{t7}</div>;
    $[9] = t7;
    $[10] = title;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}